import moment from 'moment'

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}
// 手机验证
export function rightPhoneNumber(mobile) {
    return /^1\d{10}$/gi.test(mobile)
}
// 获取链接中的参数
export function getUrlParam(item) {
    var svalue = location.hash.match(
        new RegExp('[?&]' + item + '=([^&]*)(&?)', 'i')
    )
    return svalue ? svalue[1] : svalue
}

// 格式修改
export function splitData1(arr) {
    let categoryData = []

    arr.forEach((item) => {
        var obj = {
            time:
                (Date.parse(item.CreateTime.replace(/-/g, '/')) + 8 * 60 * 60 * 1000) /
                1000,
            // time: Date.parse(item.CreateTime.replace(/-/g, '/')) / 1000,
            open: item.Open,
            high: item.High,
            low: item.Low,
            close: item.Close
        }
        categoryData.push(obj)
    })
    return categoryData
}

export function getLocalDate(value) {
    return moment(value).local().format('YYYY-MM-DD')
}
export function IsreadSysNotice() {
    const flag = sessionStorage.getItem('props')
    if (!flag) {
        sessionStorage.setItem('props', true)
        return true
    } else {
        return false
    }
}
// export function IsreadSysNotice() {
//   let obj = JSON.parse(localStorage.getItem('SysNotice'))
//   const date = new Date()
//   let m =
//     date.getMonth() + 1 > 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
//   let d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
//   let nowDate = `${m}-${d}`
//   if (obj) {
//     if (nowDate !== obj.data) {
//       localStorage.setItem(
//         'SysNotice',
//         JSON.stringify({
//           data: nowDate,
//           timer: 1
//         })
//       )
//       return true
//     }
//   } else {
//     localStorage.setItem(
//       'SysNotice',
//       JSON.stringify({
//         data: nowDate,
//         timer: 1
//       })
//     )
//     return true
//   }
// }
export function getLocalTime(value) {
    return moment(value).local().format('YYYY-MM-DD HH:mm:ss')
}
export function returnLang(lang, setLang = false) {
    let localeLang = ''
    return localeLang
}

// 余额变更类型
export const balanceChangeTypeArr = [{
            Id: 'Upper',
            Name: '存款'
        },
        {
            Id: 'Lower',
            Name: '取款'
        },
        {
            Id: 'Bet',
            Name: '投注'
        },
        {
            Id: 'Win',
            Name: '中奖'
        },
        {
            Id: 'BalanceToFinance',
            Name: '余额转收益宝'
        },
        {
            Id: 'FinanceeToBalance',
            Name: '收益宝转余额'
        },
        {
            Id: 'CashProfit',
            Name: '下级提现收益'
        }
    ]
    // 状态类型
export const TransferStatusArr = [{
        Id: 'Review',
        Name: '审核中'
    },
    {
        Id: 'Success',
        Name: '成功'
    },
    {
        Id: 'Fail',
        Name: '失败'
    }
]
//页面显示语言
const langArr = [{
    Id: 'zh',
    Name: '简体中文'
},
{
    Id: 'ft',
    Name: '繁體中文'
},
{
    Id: 'en',
    Name: 'English'
},
{
    Id: 'jp',
    Name: '日本語'
},
{
    Id: 'hy',
    Name: '한국인'
},
{
    Id: 'ty',
    Name: 'ภาษาไทย'
},
{
    Id: 'yn',
    Name: 'Indonesia'
},
{
    Id: 'yuenan',
    Name: 'Việt nam'
},
{
    Id: 'gmw',
    Name: 'កម្ពុជា'
},
{
    Id: 'fy',
    Name: 'Français'
},
{
    Id: 'xby',
    Name: 'Español'
},
{
    Id: 'ey',
    Name: 'Русский язык'
},
{
    Id: 'pty',
    Name: 'Português'
},
{
    Id: 'dy',
    Name: 'Deutsch'
},
]

/**
 * array show
 * @param {String} string
 */
export function showName(Id) {
    if (Id === 'Error') {
        return '错误'
    } else {
        let name = ''
        langArr.some((item) => {
            if (item.Id === Id) {
                name = item.Name
                return true
            }
        })
        return name
    }
}
/**
 * array show
 * @param {String} string
 */
export function showId(Name) {
    if (Name === 'Error') {
        return '错误'
    } else {
        let Id = ''
        langArr.some((item) => {
            if (item.Name === Name) {
                Id = item.Id
                return true
            }
        })
        return Id
    }
}

export function IsPC() {
    var userAgentInfo = navigator.userAgent
    var Agents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod'
    ]
    var flag = true
    for (var i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) != -1) {
            flag = false
            break
        }
    }
    return flag
}

export function dataURLtoBlob(dataUrl) {
    const arr = dataUrl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
}

export function getRandomString(len) {
    len = len || 15
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    var maxPos = $chars.length
    var pwd = ''
    for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
}

export function rTime(date) {
    var json_date = new Date(date).toJSON()
    return new Date(new Date(json_date) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
}

export function isEmptyObject(obj) {
    if (obj === null || obj === undefined) return true
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false
        }
    }
    return true
}

//获取调用api的语言头
export function getLang() {
    var lang = localStorage.getItem('language') || 'en'
    if (lang == 'zh') {
        lang = 'zh'
    }
    if (lang == 'en') {
        lang = 'en'
    }
    if (lang == 'jp') {
        lang = 'ja'
    }
    if (lang == 'hy') {
        lang = 'ko'
    }
    if (lang == 'ty') {
        lang = 'th'
    }
    if (lang == 'yn') {
        lang = 'in'
    }
    if (lang == 'yuenan') {
        lang = 'vi'
    }
    if (lang == 'gmw') {
        lang = 'km'
    }
    if (lang == 'fy') {
        lang = 'fr'
    }
    if (lang == 'xby') {
        lang = 'es'
    }
    if (lang == 'tr') {
        lang = 'tr'
    }
    if (lang == 'ey') {
        lang = 'ru'
    }
    if (lang == 'pty') {
        lang = 'pt'
    }
    if (lang == 'dy') {
        lang = 'de'
    }
    return lang
}